<template>
<div class="chapter">
<div class="inner_page">
<a id="VPS-6"></a>
<h2 class="ch-t">Acknowledgements</h2>
<p class="noindent"><span class="dropcap">T</span>he historical images in this work come from the files of the US Navy Historical Center. The contemporary photographs come from a US Navy website. Some pictures came from friends that are named. As with all published works, authors depend on friends for assistance in reviewing their work.</p>
<p class="sub-head">Notes to the Reader</p>
<p class="note"><span class="note01">1.</span> This book is not a comprehensive history of US Navy destroyers, but rather a broad overview of the subject.</p>
<p class="note"><span class="note01">2.</span> All standard ship displacements are in long tons (2,240lb to the ton).</p>
<p class="note"><span class="note01">3.</span> Stated displacements only represent a point in time of a destroyer’s service with the US Navy due to ongoing alterations and upgrades.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Acknowledgements.vue?3a74507d